import React from 'react';

export const EditIconDisable = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        style={{ opacity: 0.3 }}>
        <path
            d="M5.37745 20.6243V12.0034L13.8276 3.55322H2.93873C1.59743 3.55322 0.5 4.65065 0.5 5.99195V23.063C0.5 24.4043 1.59743 25.5018 2.93873 25.5018H20.0098C21.3511 25.5018 22.4485 24.4043 22.4485 23.063V12.1741L13.9984 20.6243H5.37745Z"
            fill="#EBB02D"
        />
        <path
            d="M7.81616 18.1854H12.9863L21.7657 9.40594L16.5956 4.23584L7.81616 13.0153V18.1854Z"
            fill="#EBB02D"
        />
        <path
            d="M24.7776 2.93117L23.0583 1.21186C22.1072 0.260759 20.5586 0.260759 19.6075 1.21186L18.3149 2.50439L23.485 7.67449L24.7776 6.38196C25.7409 5.43086 25.7409 3.88227 24.7776 2.93117Z"
            fill="#EBB02D"
        />
    </svg>
);
